import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessLayoutComponent } from '@rsm/layouts/access';

import { MainLayoutComponent } from '@rsm/layouts/main';
import { MainLayoutModule } from '@rsm/layouts/main/main-layout.module';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    loadChildren: () =>
      import('./pages/pages.module').then((module) => module.PagesModule),
  },
  {
    path: 'access',
    component: AccessLayoutComponent,
    loadChildren: () =>
      import('./access/access.module').then((module) => module.AccessModule),
  },
  {
    path: 'corporate-email',
    loadChildren: () =>
      import('./pages/corporate-email/corporate-email.module').then(
        (m) => m.CorporateEmailModule
      ),
  },
  {
    path: 'check-email-inbox',
    loadChildren: () =>
      import('./pages/check-email-inbox/check-email-inbox.module').then(
        (m) => m.CheckEmailInboxModule
      ),
  },
  {
    path: 'validar-email',
    loadChildren: () =>
      import('./pages/valid-email-token/valid-email-token.module').then(
        (m) => m.ValidEmailTokenModule
      ),
  },
  {
    path: 'company-setup',
    loadChildren: () =>
      import('./pages/company-setup/company-setup.module').then(
        (module) => module.CompanySetupModule
      ),
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [MainLayoutModule, RouterModule.forRoot(routes)],
})
export class AppRoutingModule {}
